module.exports = __webpack_public_path__ + "img/man-stands-front-mountain-looks-landscape.feec5495.webp";